// angular modules
// DSS Documentation on Angular - http://tiny.sc/cgangular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// soco modules
import { SocoCommonModule } from '@soco/common';
import { SocoConfigurationModule } from '@soco/configuration';
import { SocoFormsModule } from '@soco/forms';

// components
// DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { WebApiConfigComponent } from './web-api-config/web-api-config.component';
import { HttpService } from './navbar/http.service';

const MODULE_DIRECTIVES = [
    NavbarComponent,
    SidebarComponent,
    AccessDeniedComponent,
    PageNotFoundComponent,
    WebApiConfigComponent
];

@NgModule({
    imports: [
        // angular modules
        CommonModule,
        RouterModule,

        // soco modules
        SocoCommonModule,
        SocoConfigurationModule,
        SocoFormsModule
    ],
    providers: [HttpService],
    exports: MODULE_DIRECTIVES,
    declarations: MODULE_DIRECTIVES
})
export class CoreModule { }

